import { Colors } from '../consts/Colors';

export default class ChaineSlider extends Phaser.GameObjects.Container {
    constructor(scene, x, y, textureKeys, spacing = 750) {
        super(scene, x, y);

        this.currentIndex = 0;
        this.slides = [];
        this.spacing = spacing;
        this.baseScale = 0.7;
        this.upperScale = 1;

        const imageWidth = 480; // même que ton cadre

        textureKeys.forEach((key, index) => {
            const container = scene.add.container(0, 0);
            const frame = scene.add
                .rexRoundRectangle(0, 0, imageWidth, imageWidth, 14, Colors.Elmt.White)
                .setOrigin(0.5)
                .setVisible(false);

            const image = scene.add
                .image(0, 0, key)
                .setOrigin(0.5)
                .setInteractive({ cursor: 'pointer' })
                .setDepth(10);
            frame.setSize(image.width + 20, image.height + 20);

            const tagReponseImage = scene.add
                .image(-200, -80, 'icone_check')
                .setOrigin(0.5)
                .setDepth(30)
                .setAlpha(0);

            container.add([frame, image, tagReponseImage]);
            container.tagReponseImage = tagReponseImage;

            this.add(container);
            this.slides.push(container);
        });

        // Flèches
        const arrowOffsetX = spacing;
        const leftArrow = scene.add
            .image(-arrowOffsetX + 350, 0, 'fleche-activite-1')
            .setOrigin(0.5)
            .setScale(1.5)
            .setInteractive({ cursor: 'pointer' })
            .on('pointerdown', () => this.moveTo(this.currentIndex - 1));
        leftArrow.setAngle(180);
        this.add(leftArrow);

        const rightArrow = scene.add
            .image(arrowOffsetX - 350, 0, 'fleche-activite-1')
            .setOrigin(0.5)
            .setScale(1.5)
            .setInteractive({ cursor: 'pointer' })
            .on('pointerdown', () => this.moveTo(this.currentIndex + 1));
        this.add(rightArrow);

        this.updateSlider(); // Initial render
        scene.add.existing(this);
    }

    moveTo(index) {
        if (index < 0 || index >= this.slides.length) return;
        this.currentIndex = index;
        this.updateSlider();

        if (this.scene.updateValiderButtonState) {
            this.scene.updateValiderButtonState();
        }
    }

    updateSlider() {
        const centerX = 0; // Le centre de ce Container (x=0)

        this.slides.forEach((container, i) => {
            const relativeIndex = i - this.currentIndex;

            const targetX = relativeIndex * this.spacing;

            const scale = i === this.currentIndex ? this.upperScale : this.baseScale;

            this.scene.tweens.add({
                targets: container,
                x: targetX,
                scale,
                duration: 400,
                ease: 'Sine.easeInOut',
            });
        });
    }
}
